<template>
    <b-container fluid>
        <iq-card>
            <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t('social_service.cash_flow_report') }} {{ $t('globalTrans.search') }}</h4>
            </template>
            <template v-slot:body>
                <b-overlay :show="unitLoad">
                <b-row>
          <b-col xl="12" lg="12" sm="12">
            <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
              <b-form  @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset" enctype="multipart/form-data">
                <b-row>
                  <!-- Division -->
                  <b-col xl="6" lg="6" sm="12" v-if="sysCall === 0">
                    <ValidationProvider name="Division" vid="division_id" >
                        <b-form-group
                          class="row"
                          label-cols-sm="3"
                          label-for="division_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.division')}}
                        </template>
                        <b-form-select
                          plain
                          v-model="search.division_id"
                          :options="divisionList"
                          id="division_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>

                  <!-- District -->
                  <b-col xl="6" lg="6" sm="12" v-if="sysCall === 0">
                    <ValidationProvider name="District" vid="district_id">
                        <b-form-group
                          class="row"
                          label-cols-sm="3"
                          label-for="district_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.district')}}
                        </template>
                        <b-form-select
                          plain
                          v-model="search.district_id"
                          :options="districtList"
                          id="district_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>

                  <!-- Hospital -->
                  <b-col xl="6" lg="6" sm="12">
                    <ValidationProvider name="Hospital" vid="hospital_id" rules="required|min_value:1">
                        <b-form-group
                          class="row"
                          label-cols-sm="3"
                          label-for="hospital_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('social_service.hospital_name')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          plain
                          v-model="search.hospital_id"
                          :options="hospitalList"
                          id="hospital_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>

                  <!-- Year -->
                  <b-col xl="6" lg="6" sm="12">
                    <ValidationProvider name="year" vid="fiscal_year_id" rules="required|min_value:1">
                        <b-form-group
                          class="row"
                          label-cols-sm="3"
                          label-for="fiscal_year_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('retailerManagement.year')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          plain
                          v-model="search.year_id"
                          :options="yearList"
                          id="fiscal_year_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>

                  <!-- Month -->
                  <b-col xl="6" lg="6" sm="12">
                    <ValidationProvider name="Month" vid="month_id" rules="required|min_value:1">
                        <b-form-group
                          class="row"
                          label-cols-sm="3"
                          label-for="month_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('production_store.month')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          plain
                          v-model="search.month_id"
                          :options="monthList"
                          id="month_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Search Button -->
                  <b-col xl="12" lg="12" sm="12">
                    <div class="col text-right">
                      <b-button type="submit" variant="primary" class="mr-2">{{ $t('globalTrans.search') }}</b-button>
                    </div>
                  </b-col>
                </b-row>
              </b-form>
            </ValidationObserver>
          </b-col>
        </b-row>
                </b-overlay>
            </template>
        </iq-card>
        <iq-card>
            <template slot:body>
                <div class="col-md-12" >
                    <!-- report head data -->
                    <b-row v-if="reportHeadData">
                        <b-col xs="12" sm="12" md="12" class="text-right">
                            <b-button-group>
                                <b-button variant="success" @click="pdfExport">
                                    <i style="font-size: 18px; margin: 0; padding: 0;" class="ri-printer-fill"></i>
                                </b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="reportHeadData">
                        <b-col xs="12" sm="12" md="3" class="text-right mt-3">
                            <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                        </b-col>
                        <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                            <h3 class="text-bold">
                                {{ $t('production_store.govt_info') }}
                            </h3>
                            <h4 class="text-center text-dark">
                                {{ $t('social_service.dss') }}
                            </h4>
                            <!-- <span class="text-center text-dark">
                                {{ reportHeadData.heading }}
                            </span><br> -->
                            <span class="text-center text-dark">
                                {{ reportHeadData.address }}
                            </span><br>
                            <div class="titleDiv">
                                <span class="text-center text-dark reportTitle" style="font-weight:bold;">
                                    {{ $t('report.cash_register') }}
                                </span><br>
                            </div>
                        </b-col>
                        <b-col xs="12" sm="12" md="3" class="text-left mt-3">
                            <b-img :src="`${ reportHeadData.reportHeadColumn[1].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                        </b-col>
                    </b-row>
                    <b-overlay :show="unitLoad">
                    <!-- report head data -->
                    <b-row v-if="isShowCashRegister && reportHeadData">
                        <b-col xs="12" sm="12" md="6" class="text-left">
                            <span v-if="titleData.year" class="text-center text-dark"><b>{{ $t('report.year') }} </b>: {{ titleData.year }}</span> <br>
                            <span v-if="titleData.monthName" class="text-center text-dark"><b>{{ $t('report.month_name') }} </b>: {{ titleData.monthName }}</span>
                        </b-col>
                        <b-col xs="12" sm="12" md="6" class="text-right">
                            <span v-if="titleData.hosName" class="text-center text-dark"><b>{{ $t('social_service.hospital') }} </b>: {{ titleData.hosName }}</span>
                        </b-col>
                        <b-col md="12" class="table-responsive">
                            <b-table-simple  bordered hover responsive class="mt-4">
                                <b-tr>
                                    <b-th colspan="5">{{ $t('report.income_first') }}</b-th>
                                    <b-th colspan="6"> {{ $t('report.expenses') }}</b-th>
                                </b-tr>
                                <tr>
                                    <b-th>{{ $t('report.sl_no') }}</b-th>
                                    <b-th>{{ $t('report.date') }}</b-th>
                                    <b-th>{{ $t('report.description') }}</b-th>
                                    <b-th>{{ $t('report.hand_deposite') }}</b-th>
                                    <b-th>{{ $t('report.bank_deposote') }}</b-th>
                                    <b-th>{{ $t('report.sl_no') }}</b-th>
                                    <b-th>{{ $t('report.voucher_no') }}</b-th>
                                    <b-th>{{ $t('report.date') }}</b-th>
                                    <b-th>{{ $t('report.description') }}</b-th>
                                    <b-th>{{ $t('report.cost_expenses') }}</b-th>
                                    <b-th>{{ $t('report.withdraw_bank') }}</b-th>
                                </tr>
                                <b-tr v-for="(row,index) in cashRegister" :key="index">
                                    <b-th>{{$n(row.incomeSerial)}}</b-th>
                                    <!--<b-th>{{row.incomeDate | dateFormat }}</b-th>-->
                                    <b-th>{{rowDate | dateFormat}}</b-th>
                                    <b-th>{{ row.incomeDesc==='ancestor'?$t('report.ancestor') : row.incomeDesc==='deposit'? $t('report.bank_deposit_cash') : row.incomeDesc==='withdraw'? $t('report.withdraw') :''}}</b-th>
                                    <b-th>{{$n(row.incomeHand)}}</b-th>
                                    <b-th>{{$n(row.incomeBank)}}</b-th>
                                    <b-th>{{$n(row.expenseSerial)}}</b-th>
                                    <b-th></b-th>
                                    <b-th>{{row.expenseDate}}</b-th>
                                    <b-th>{{ row.expenseDesc === 'withdraw' ? $t('report.withdraw'): row.expenseDesc === 'expense'? $t('report.expense') :''}}</b-th>
                                    <b-th>{{$n(cost)}}</b-th>
                                    <b-th>{{$n(bankCharge)}}</b-th>
                                </b-tr>
                                <b-tr>
                                    <b-th></b-th>
                                    <b-th></b-th>
                                    <b-th>--</b-th>
                                    <b-th></b-th>
                                    <b-th></b-th>
                                    <b-th></b-th>
                                    <b-th></b-th>
                                    <b-th></b-th>
                                    <b-th>--</b-th>
                                    <b-th></b-th>
                                    <b-th></b-th>
                                </b-tr>
                                <b-tr>
                                    <b-th></b-th>
                                    <b-th></b-th>
                                    <b-th>--</b-th>
                                    <b-th></b-th>
                                    <b-th></b-th>
                                    <b-th></b-th>
                                    <b-th></b-th>
                                    <b-th></b-th>
                                    <b-th>{{ $t('report.total') }} =</b-th>
                                    <b-th>{{$n(monthExpense)}}</b-th>
                                    <b-th>{{$n(monthWithdraw)}}</b-th>
                                </b-tr>
                                <b-tr>
                                    <b-th></b-th>
                                    <b-th></b-th>
                                    <b-th>--</b-th>
                                    <b-th></b-th>
                                    <b-th></b-th>
                                    <b-th></b-th>
                                    <b-th></b-th>
                                    <b-th colspan="2">{{ $t('report.hand_bank') }}</b-th>
                                    <b-th>{{$n(monthWithdraw+handAncester-monthExpense)}}</b-th>
                                    <b-th>{{$n(bankAncester+monthDeposit-monthWithdraw-bankCharge)}}</b-th>
                                </b-tr>
                                <b-tr>
                                    <b-th></b-th>
                                    <b-th></b-th>
                                    <b-th>{{ $t('report.in_total') }} =</b-th>
                                    <b-th>{{$n(monthWithdraw+handAncester)}}</b-th>
                                    <b-th>{{$n(bankAncester+monthDeposit)}}</b-th>
                                    <b-th></b-th>
                                    <b-th></b-th>
                                    <b-th colspan="2">{{ $t('report.in_total') }} =</b-th>
                                    <b-th>{{$n(monthWithdraw+handAncester+cost)}}</b-th>
                                    <b-th>{{$n(bankAncester+monthDeposit)}}</b-th>
                                </b-tr>
                            </b-table-simple>
                        </b-col>
                    </b-row>
                </b-overlay>
                </div>
            </template>
        </iq-card>
<!--        <b-modal id="modal-detail-umo" size="xl" :title="detailTitle" :ok-title="$t('globalTrans.close')" ok-only-->
<!--                 ok-variant="danger">-->
<!--            <DetailModalUMO :id="editItemId" :key="editItemId" :item="item"/>-->
<!--        </b-modal>-->
    </b-container>
</template>
<script>
// import DetailModalUMO from './DetailModalUMO'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { socialServiceCashFlowReportApi, campaignDesignationToggleStatusApi, assignUserHospitalApi } from '../../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import iqCard from '../../../../../../components/core/cards/iq-card.vue'
import ReportHeading from '@/Utils/report-head'
import ExportPdf from './export-pdf-details'
export default {
  components: { iqCard },
    mixins: [ModalBaseMasterList],
    // components: {
    //     DetailModalUMO
    // },
    data () {
        return {
            sysCall: 0,
            hospitalList: [],
            hospitalIds: [],
            userId: 0,
            search: {
                fis_id: 0,
                division_id: 0,
                district_id: 0,
                hospital_id: 0,
                year_id: 0,
                month_id: 0
            },
            titleData: {
                year: '',
                monthName: '',
                hosName: ''
            },
            rowDate: '',
            bankCharge: 0,
            editItemId: '',
            item: '',
            rows: [],
            districtList: [],
            upazillaList: [],
            bankAncester: 0,
            handAncester: 0,
            monthWithdraw: 0,
            monthDeposit: 0,
            monthExpense: 0,
            monthAllExpenses: [],
            monthAllDeposit: [],
            isShowCashRegister: false,
            cashRegister: [],
            reportHeadData: null,
            unitLoad: false
        }
    },
    created () {
      this.hospitalLoad = true
        var officeId = this.$store.state.Auth.authUser.office_id
        if (officeId > 1) {
            this.userId = this.$store.state.Auth.authUser.user_id
            if (this.userId > 1) {
              this.sysCall = 1
                this.getUserWiseHospital(this.userId)
            }
        } else {
            this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
                this.hospitalIds.push(obj.value)
            })
            this.hospitalList = this.getHospitalListAll()
            this.unitLoad = false
        }
        if (this.$store.state.Auth.activeRoleId !== 1) {
            this.userId = this.$store.state.Auth.authUser.user_id
            if (this.$store.state.Auth.authUser.is_org_admin !== 1) {
            this.getUserWiseHospital(this.userId)
            }
        }
      this.unitLoad = false
    },
    computed: {
        formTitle () {
            return (this.editItemId === 0) ? this.$t('social_service.dashbboard') + ' ' + this.$t('globalTrans.entry') : this.$t('social_service.dashbboard') + ' ' + this.$t('globalTrans.modify')
        },
        detailTitle () {
            return 'Detail Title'
        },
        divisionList: function () {
            return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
        },
        monthList: function () {
            const objectData = this.$store.state.commonObj.monthList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return {
                        value: obj.value,
                        text: obj.text_bn
                    }
                } else {
                    return {
                        value: obj.value,
                        text: obj.text_en
                    }
                }
            })
        },
        MonthList: function () {
            const list = [
                {
                    value: 1,
                    text: this.$t('months.jan')
                },
                {
                    value: 2,
                    text: this.$t('months.feb')
                },
                {
                    value: 3,
                    text: this.$t('months.mar')
                },
                {
                    value: 4,
                    text: this.$t('months.apr')
                },
                {
                    value: 5,
                    text: this.$t('months.may')
                },
                {
                    value: 6,
                    text: this.$t('months.jun')
                },
                {
                    value: 7,
                    text: this.$t('months.jul')
                },
                {
                    value: 8,
                    text: this.$t('months.aug')
                },
                {
                    value: 9,
                    text: this.$t('months.sep')
                },
                {
                    value: 10,
                    text: this.$t('months.oct')
                },
                {
                    value: 11,
                    text: this.$t('months.nov')
                },
                {
                    value: 12,
                    text: this.$t('months.dec')
                }
            ]
            return list
        },
        yearList: function () {
            const data = this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
            const years = data.map((obj, key) => {
                // const year = obj.text.split('-')[0]
                return { value: obj.text_en.split('-')[1], text: obj.text }
            })
            // Getting the last year on the end of the Fiscal Year List
            // const lastYear = (data[data.length - 1].text.split('-')[1])
            // years.push({ value: lastYear, text: lastYear })
            return years
        },
        fiscalyearList: function () {
            return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
        },
        columns () {
            const labels = [
                {
                    label: this.$t('globalTrans.sl_no'),
                    class: 'text-left'
                },
                {
                    label: this.$t('social_service.patient_name'),
                    class: 'text-left'
                },
                {
                    label: this.$t('social_service.auto_id'),
                    class: 'text-left'
                },
                {
                    label: this.$t('globalTrans.date'),
                    class: 'text-left'
                },
                {
                    label: this.$t('globalTrans.status'),
                    class: 'text-center'
                },
                {
                    label: this.$t('globalTrans.action'),
                    class: 'text-center'
                }
            ]

            let keys = []

            if (this.$i18n.locale === 'bn') {
                keys = [
                    { key: 'index' },
                    { key: 'patient_name_bn' },
                    { key: 'auto_id' },
                    { key: 'reg_date' },
                    { key: 'status' },
                    { key: 'action' }
                ]
            } else {
                keys = [
                    { key: 'index' },
                    { key: 'patient_name' },
                    { key: 'auto_id' },
                    { key: 'reg_date' },
                    { key: 'status' },
                    { key: 'action' }
                ]
            }

            return labels.map((item, index) => {
                return Object.assign(item, keys[index])
            })
        }
    },
    watch: {
        loadingState: function (newVal, oldVal) {
            if (newVal) {
                this.loadData()
            }
        },
        'search.division_id': function (newVal, OldVal) {
            this.search.district_id = 0
            this.districtList = this.getDistrictListByDivisionId(this.search.division_id)
        },
        'search.district_id': function (newVal, OldVal) {
            this.search.hospital_id = 0
            this.hospitalList = this.getHospitalListByDistrictId(this.search.district_id)
        },
        'search.year_id': function (newVal, OldVal) {
            if (newVal !== OldVal) {
                this.getFiscalYear()
            }
        },
        'search.month_id': function (newVal, OldVal) {
            if (newVal !== OldVal) {
                this.getMonthName()
            }
        },
        'search.hospital_id': function (newVal, OldVal) {
            if (newVal !== OldVal) {
                this.getHospitalName()
            }
        }
    },
    methods: {
        async getUserWiseHospital (userId) {
            const params = Object.assign({ user_id: userId })
            const result = await RestApi.getData(hospitalServiceBaseUrl, assignUserHospitalApi, params)
            if (result.success) {
                    this.hospitalIds = result.data
            } else {
                this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
                    this.hospitalIds.push(obj.value)
                })
            }
            this.hospitalList = this.getHospitalList()
            if (this.hospitalList.length) {
                this.search.hospital_id = this.hospitalList[0].value
            }
        },
        getHospitalList () {
            let hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
            if (this.hospitalIds.length > 0) {
            hospitalList = hospitalList.filter((p) => this.hospitalIds.includes(p.value))
            }
            this.hospitalLoad = false
            this.unitLoad = false
            return hospitalList
        },
        async headerName () {
            this.loadingReportHeadData = true
            const result = await ReportHeading.getReportHead(hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3)
            this.reportHeadData = result
            this.loadingReportHeadData = false
            this.unitLoad = false
        },
        monthNameById () {
            const unit = this.MonthList.find(unit => unit.value === this.search.month_id)
            if (this.$i18n.locale === 'bn') {
                return unit.text
            } else {
                return unit.text
            }
        },
        getDistrictListByDivisionId (divisionId = null) {
            return this.$store.state.commonObj.districtList.filter(item => item.status === 0 && item.division_id === divisionId)
        },
        getHospitalListByDistrictId (districtId = null) {
            return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.district_id === districtId)
        },
        getHospitalListAll: function () {
          return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
        },
        searchData () {
           // this.$bvModal.show('modal-detail-umo')
            this.loadData()
        },
        edit (item) {
            this.editItemId = item.id
            this.item = item
        },
        remove (item) {
            this.changeStatus(hospitalServiceBaseUrl, campaignDesignationToggleStatusApi, item)
        },
        loadData () {
            this.unitLoad = true
            this.search.fis_id = this.$store.state.commonObj.fiscalYearList.find(obj => obj.text_en.split('-')[1] === this.search.year_id).value
            if (this.search.year_id !== 0 && this.search.month_id !== 0) {
                RestApi.getData(hospitalServiceBaseUrl, socialServiceCashFlowReportApi, this.search).then(response => {
                    if (response.success) {
                        this.unitLoad = false
                        this.bankAncester = response.bankAncester
                        this.bankCharge = response.bankCharge
                        this.rowDate = response.rowDate
                        this.cost = response.cost
                        this.handAncester = response.handAncester
                        this.monthWithdraw = response.thisMonthWithdraw
                        this.monthDeposit = response.thisMonthDeposit
                        this.monthExpense = response.thisMonthExpense
                        this.monthAllExpenses = response.thisMonthAllExpenses
                        this.monthAllDeposit = response.thisMonthAllDeposit
                        var arraySize = this.monthAllDeposit.length + 1 > this.monthAllExpenses.length ? this.monthAllDeposit.length + 1 : this.monthAllExpenses.length
                        var row, incomeSerial, expenseSerial, expenseDate, expenseDesc, expenseHand, expenseBank, incomeDate, incomeDesc, incomeHand, incomeBank
                        this.cashRegister = []
                        for (var i = 0; i < arraySize; i++) {
                            if (this.monthAllExpenses[i]) {
                                expenseSerial = i + 1
                                expenseDate = this.monthAllExpenses[i].date
                                expenseDesc = this.monthAllExpenses[i].description
                                expenseHand = this.monthAllExpenses[i].description === 'expense' ? this.monthAllExpenses[i].amount : ''
                                // expenseBank = this.monthAllExpenses[i].description === 'withdraw' ? this.monthAllExpenses[i].amount : ''
                            } else {
                                expenseSerial = ''
                                expenseDate = ''
                                expenseDesc = ''
                                expenseHand = ''
                                expenseBank = ''
                            }
                            var depositIndex = i - 1
                            if (this.monthAllDeposit[depositIndex]) {
                                incomeSerial = i + 1
                                incomeDate = this.monthAllDeposit[depositIndex].date
                                incomeDesc = this.monthAllDeposit[depositIndex].description
                                incomeHand = this.monthAllDeposit[depositIndex].description === 'withdraw' ? this.monthAllDeposit[depositIndex].amount : ''
                                incomeBank = this.monthAllDeposit[depositIndex].description === 'deposit' ? this.monthAllDeposit[depositIndex].amount : ''
                            } else {
                                incomeSerial = ''
                                incomeDate = ''
                                incomeDesc = ''
                                incomeHand = ''
                                incomeBank = ''
                            }
                            if (i === 0) {
                                 row = {
                                     incomeSerial: 1,
                                     expenseSerial,
                                    incomeDate: '',
                                    incomeDesc: 'ancestor',
                                    incomeHand: this.handAncester,
                                    incomeBank: this.bankAncester,
                                     expenseDate,
                                     expenseDesc,
                                     expenseHand,
                                     expenseBank
                                }
                            } else {
                                 row = {
                                     incomeSerial,
                                     expenseSerial,
                                     incomeDate,
                                     incomeDesc,
                                     incomeHand,
                                     incomeBank,
                                     expenseDate,
                                     expenseDesc,
                                     expenseHand,
                                     expenseBank
                                }
                            }
                            this.cashRegister.push(row)
                        }
                        this.isShowCashRegister = true
                        this.headerName()
                    }
                })
            }
        },
        getRelationalData (data) {
            const listData = data.map(item => {
                const designationData = {
                    designation: item.designation_bn !== undefined ? item.designation : '',
                    designation_bn: item.designation !== undefined ? item.designation_bn : ''
                }

                return Object.assign({}, item, designationData)
            })
            return listData
        },
        getFiscalYear () {
            const Year = this.yearList.find(item => item.value === this.search.year_id)
            this.titleData.year = Year.text
        },
        getMonthName () {
            const Month = this.monthList.find(item => item.value === this.search.month_id)
            if (this.$i18n.locale === 'bn') {
                this.titleData.monthName = Month.text
            } else {
                this.titleData.monthName = Month.text
            }
        },
        getHospitalName () {
            const Hospital = this.hospitalList.find(item => item.value === this.search.hospital_id)
            if (this.$i18n.locale === 'bn') {
                this.titleData.hosName = Hospital.text_bn
            } else {
                this.titleData.hosName = Hospital.text_en
            }
        },
        pdfExport () {
            const reportTitle = this.$t('social_service.cash_flow_report')
            ExportPdf.exportPdfDetails(hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, this.cashRegister, this, this.titleData)
        }
    }
}
</script>
<style scoped>
    .titleDiv {
        font-size: 18px;
    }
    .text-message {
        font-weight: bold;
        font-size: 24px;
        color: rgba(63, 62, 62, 0.418);
    }
</style>
